import { getEnv } from '@config';
import { axiosInstance } from '@services/base-service';

const basePath = '/andes/bff/transactions';
const transactionsUri = '/merchant/bff/transactions';
const { transactionsPerPage } = getEnv();

export const getMerchantBalance = async (merchantId) =>
  axiosInstance.getInstance().get(`${basePath}/balances/${merchantId}`);

export const getGscBalance = (sellerId) =>
  axiosInstance.getInstance().get(`${basePath}/balances/gsc/${sellerId}`);

export const getAllBalance = (query) =>
  axiosInstance
    .getInstance()
    .get(`${transactionsUri}/transactions/all/merchants?${query}&per_page=${transactionsPerPage}`);

export const postInstallmentsSimulate = (financed_amount) =>
  axiosInstance
    .getInstance()
    .post(`${transactionsUri}/merchants/installments-calculator`, { payload: { financed_amount } });
